import React from 'react';
import { Redirect } from 'react-router-dom';

export const Redirector = () => <Redirect to="/promotions/dd247591-7ea5-4028-b8aa-604e5eca2e1b" />
